import Nullstack from 'nullstack';
export default function IconSunWind({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sun-wind",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14.468 10.005a4 4 0 1 0 -5.466 5.46"
  }), "   ", Nullstack.element("path", {
    d: "M2 12h1"
  }), "   ", Nullstack.element("path", {
    d: "M11 3v1"
  }), "   ", Nullstack.element("path", {
    d: "M11 20v1"
  }), "   ", Nullstack.element("path", {
    d: "M4.6 5.6l.7 .7"
  }), "   ", Nullstack.element("path", {
    d: "M17.4 5.6l-.7 .7"
  }), "   ", Nullstack.element("path", {
    d: "M5.3 17.7l-.7 .7"
  }), "   ", Nullstack.element("path", {
    d: "M15 13h5a2 2 0 1 0 0 -4"
  }), "   ", Nullstack.element("path", {
    d: "M12 16h5.714l.253 -.004a2.004 2.004 0 0 1 2.033 2.004a2 2 0 0 1 -2 2h-.286"
  }), " ");
}